import React from 'react'
import DpeScore from './DpeScore'
import { useTranslation } from 'next-i18next'

type DpeChartProps = {
  score: number
}

export default function DpeChart({ score }: DpeChartProps) {
  const { t } = useTranslation('originals/property')

  return (
    <div className="w-full">
      <div className="pb-4">
        <DpeScore score={score} />
      </div>
      <div className="grid grid-rows-7 gap-1">
        <div className="flex w-3/12 rounded-md bg-green-700 px-2 py-0.5 text-xs text-white">
          <div>69</div>
          <div className="ml-auto font-bold">A</div>
        </div>
        <div className="flex w-4/12 rounded-md bg-green-600 px-2 py-0.5 text-xs text-white">
          <div>70 à 109</div>
          <div className="ml-auto font-bold">B</div>
        </div>
        <div className="flex w-5/12 rounded-md bg-amber-300 px-2 py-0.5 text-xs text-white">
          <div>110 à 179</div>
          <div className="ml-auto font-bold">C</div>
        </div>
        <div className="flex w-6/12 rounded-md bg-amber-500 px-2 py-0.5 text-xs text-white">
          <div>180 à 249</div>
          <div className="ml-auto font-bold">D</div>
        </div>
        <div className="flex w-7/12 rounded-md bg-amber-600 px-2 py-0.5 text-xs text-white">
          <div>250 à 329</div>
          <div className="ml-auto font-bold">E</div>
        </div>
        <div className="flex w-8/12 rounded-md bg-amber-700 px-2 py-0.5 text-xs text-white">
          <div>330 à 419</div>
          <div className="ml-auto font-bold">F</div>
        </div>
        <div className="flex w-9/12 rounded-md bg-red-700 px-2 py-0.5 text-xs text-white">
          <div>420</div>
          <div className="ml-auto font-bold">G</div>
        </div>
      </div>
      <div className="pt-1 text-xs font-thin text-neutralBlack">
        {t('dpeAndWorkSection.dpe.kWhEP')}
      </div>
    </div>
  )
}
